import "@/styles/globals.css";
import Layout from "@/components/layout";
import { DefaultSeo } from "next-seo";
import { LazyMotion, domAnimation } from "framer-motion";
import { SingleModalProvider } from "@/contexts";
// import { Partytown } from "@builder.io/partytown/react";
import { GoogleAnalytics, GoogleTagManager } from "@next/third-parties/google";
export default function App({ Component, pageProps, router }) {
  return (
    <SingleModalProvider>
        {/* <Partytown debug={true} forward={["dataLayer.push"]} /> */}
        <LazyMotion features={domAnimation}>
          <DefaultSeo
            title="People’s Courage International | Non-Profit Charity Organizations in USA"
            defaultTitle="People’s Courage International | Non-Profit Charity Organizations in USA"
            description="People’s Courage International is a USA-based not-for-profit organization. Join our charity and help us provide critical support to those in need around the world."
            canonical="https://peoplescourageinternational.org"
            openGraph={{
              url: "https://peoplescourageinternational.org",
              title:
                "People’s Courage International | Non-Profit Charity Organizations in USA",
              description:
                "People’s Courage International is a USA-based not-for-profit organization. Join our charity and help us provide critical support to those in need around the world.",
              images: [
                {
                  url: "https://peoplescourageinternational.org/images/pci-logo-512x512.webp",
                  width: 140,
                  height: 140,
                  alt: "People’s Courage International",
                },
              ],
            }}
            twitter={{
              // handle: "@avneesh0612",
              // site: "@avneesh0612",
              cardType: "summary_large_image",
            }}
            additionalLinkTags={[
              {
                rel: "icon",
                href: `/pci-favicon.png`,
              },
              {
                rel: "apple-touch-icon",
                href: "/pci-favicon.png",
                sizes: "76x76",
              },
            ]}
          />
          <Layout>
            <div className="h-auto w-full">
              <Component {...pageProps} key={router.route} />
            </div>
            {/* Analytics live outside the page wrapper so they persist
                across navigations instead of re-mounting each time. */}
            <GoogleTagManager gtmId="GTM-W2RR5JF" />
            <GoogleAnalytics gaId="G-74BYMVVHM8" />
            {/* <GoogleAnalytics gaId="G-B2B2STS0RF" /> */}
          </Layout>
        </LazyMotion>
      </SingleModalProvider>
  );
}
